import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

import ndoto from '../assets/ndoto.jpg';
import './Login.css';
import logo from '../assets/logo.png'
import logo1 from '../assets/beauty_logo.png'
import logo_banner from '../assets/logo-banner.jpg'
import fashion from '../assets/fasshionnew.png'

import luxury from '../assets/luxurynew.png'
import comedy from '../assets/loltv.png'
import ndotoStream from '../assets/ndotostream.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useNavigate,useSearchParams } from 'react-router-dom';
import Loading from './Loading';
import { useSelector, useDispatch } from 'react-redux';
import {
  setPhoneNumber,
  setUserExists,
  setUserData,
  setIsActive,
  setLoading,
} from '../slices/authSlice';
import { setCategoryName } from '../slices/categorySlice';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import MainLoader from './MainLoader';
import lolbanner from '../assets/lol-bannner.jpg'
import fashionbanner from '../assets/fashion-banner.jpg'
import luxurybanner from '../assets/luxury-banner.jpg'
import sportsbanner from '../assets/sports-banner.png'
import businessbanner from '../assets/business-banner.jpg'
import wohbanner from '../assets/woh-banner.png'
import topicsbanner from '../assets/topics-banner.png'
import { baseUrl } from '../data/data';
import Loader from './Loader';

import { v4 as uuidv4 } from 'uuid';

// import { baseUrl } from '../data/data';


function Evina({ isBeautySubdomain }) {
  // const categoryname = useSelector((state) => state.category.categoryname);
  // console.log("name", categoryname)
  const [q] = useSearchParams();
  let ext_ref = q.get("ext_ref");
  let svc_name=q.get("svc_name")
  let msisdn=q.get("msisdn")
  const dispatch = useDispatch();
  const phoneNumber = useSelector((state) => state.auth.phoneNumber);

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [logo, setLogo] = useState([])
  const navigate = useNavigate();
  const [initialLoading, setInitialLoading] = useState(true);
  const [buttonClicked, setButtonClicked] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setInitialLoading(false);
    }, 3000);
  }, []);


  const subdomain = window.location.hostname.split('.')[0];
  console.log(subdomain)
  // const subdomain ='Beauty'
  // const subdomain ='videos'

function generateUniqueId() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 10; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}



const [loading,setLoading] = useState(false)
const [tVal,setTVal] = useState('');


const url = new URL(window.location.href); // Get the current page URL
  const extId = url.searchParams.get("ext_ref") || generateUniqueId(); 

const serviceMap={
  faith:"FaithFirst",
  videos:"NdotoStream"
}



      const serviceName = serviceMap[subdomain];
console.log(serviceName,"===servicename====")

  const getScript=async()=> {
      setLoading(true);


      // const ru = `https://faith.ndotomobile.com/success?ext_ref=${extId}`
      // const ru = `https://sdp-p-vas-payment.telkom.co.za/52?ext_ref=${extId}`
      // const rfu = `https://faith.ndotomobile.com/failed?ext_ref=${extId}`


     
  let ru = "";
  let rfu = "";

  if(subdomain=="faith"){
    //  ru = `https://sdp-p-vas-payment.telkom.co.za/52?ext_ref=${extId}`
         ru = `https://sdp-p-vas-payment.telkom.co.za/10011?ext_ref=${extId}`
    rfu = `https://faith.ndotomobile.com/failed?ext_ref=${extId}`
  }

  else if(subdomain=="videos"){
    // ru=`https://sdp-p-vas-payment.telkom.co.za/41?ext_ref=${extId}`
        ru=`https://sdp-p-vas-payment.telkom.co.za/10117?ext_ref=${extId}`
      rfu=`https://videos.ndotomobile.com/failed?ext_ref=${extId}`

  }


      try {
        
        const getScript = await axios.get(`https://sdpcallback.ndotomedia.com/evina?ext_id=${extId}&service=${serviceName}&ru=${ru}&rfu=${rfu}`)

        console.log(getScript.data.data)
        // const getScriptURL = `${ENDPOINT_URL}?applicationId=193&countryId=207&requestId=${evinaRequestId}`;
        console.log("script url--- ", getScript.data.data.s);
        // const response = await axios.get(getScriptURL.data);

        // if (!response.ok) {
        //   throw new Error(
        //     `Failed to fetch script: ${response.status} ${response.statusText}`
        //   );
        // }

        const scriptContent = await getScript.data.data.s;
        console.log("response----- " + scriptContent);
        // setAntiFrauduniqid(scriptContent["AntiFrauduniqid"]);

        console.log("response " + scriptContent[100]);

        setTVal(getScript.data.data?.t)


        // extId =  await getScript.data.ti;

        if (scriptContent) {
          let top_head = document.getElementsByTagName("head")[0];
          let anti_script = document.createElement("script");

          anti_script.innerHTML = scriptContent;
          top_head.insertBefore(anti_script, top_head.firstChild);

          var event = new Event("DCBProtectRun");
          // console.log(event);
          document.dispatchEvent(event);
          document.addEventListener("gateway-load", (event) => {
            //Enable form submission
            // setScriptLoaded(true);
            console.log(event, "EVENT LOADED");
          });
        }

      } catch (error) {
        console.error("Error fetching script", error);
      } finally {
        setTimeout(()=>{
            setLoading(false);
        //  window.location.replace(`https://sdp-p-vas-payment.telkom.co.za/52?ext_ref=${extId}&gv_id=40`)
        },3000)
      }
    }


    useEffect(()=>{
      getScript()
    },[])







  const fetchLogo = async () => {

    try {
     
      console.log(subdomain,"-----")
      // ${baseUrl}
      const response = await axios.get(`${baseUrl}/api/logos/${subdomain}`);
      setLogo(response.data);

    } catch (error) {
      console.error('Error fetching banners:', error);
    }
  };

  useEffect(() => {
    fetchLogo()
  }, [subdomain])
  


//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("ani ", phoneNumber);

//     const svcIdMap = {
//       beauty: "55",
//       topics: "58",
//       bossmoves: "93",
//       comedy:"91",
//       woh:"90",
//       sports:"56",
//       fashion:"54",
//       luxury:"53",

//     };
  
//     // Determine svc_id based on subdomain
//     const svc_id = svcIdMap[subdomain] || "41"; 

// console.log("ext", ext_ref)

//     // const url = 'http://88.99.5.236:6089/subscription';
//     // const url = `${baseUrl}/subscription`;
// const url='http://sdpcallback.ndotomedia.com/subscription'
//     setButtonDisabled(true);
//     try {
//       console.log("ani", phoneNumber)

//       if (msisdn == '8950022334') {
//         navigate(`/redirect?service=${svc_name}&msisdn=${msisdn}&result=active`)
//          setLoading(false);
//          return;
//        }

//       const response = await axios.post(url, {
//         msisdn: phoneNumber,
//         svc_id: svc_id,
//         ext_ref: ext_ref,
//         channel: "WAP",
//         doi_channel:"WAP",
//         svc_name:subdomain
//       });



//       console.log(response.data);
//       const subid = response.data.result.subscription_id
//       const ext = response.data.result.ext_ref
//       const svcid = response.data.result.svc_id
//       if (response.data.statusId == '1') {

//         Cookies.set('msisdn', phoneNumber, { expires: 1 })

//         dispatch(setLoading(true));

//         dispatch(setUserExists(true));
//         // dispatch(setUserData(data.user));
//         // dispatch(setCategoryName(fetchedServiceType))
//         // dispatch(setIsActive(active));
//         dispatch(setLoading(false));
//         setButtonClicked(true);
//         setTimeout(() => {
//           navigate(`/redirect/${subdomain}?msisdn=${phoneNumber}&result=Active`);
//           setButtonDisabled(false);
//           setButtonClicked(false);  
//         }, 2000);
//       }
      
//       if (response.data.statusId == '0') {
//         window.location.replace(`https://sdp-p-vas-payment.telkom.co.za/${svcid}?msisdn=${phoneNumber}&subscription_id=${subid}&ext_ref=${ext_ref}`)
//       }

//       //  https://sdp-s-vas-payment.telkom.co.za/<svc_id>?msisdn=<ani>&subscription_id=<subsubscription_id>&ext_ref=<ext_ref>

//       setButtonDisabled(false);
//       setButtonClicked(false);  

//     } catch (error) {
//       console.error('Error during subscription check:', error);
//       toast.error("Failed to check subscription!");
//       setButtonDisabled(false);
//           setButtonClicked(false);  
//     }
//   }


  if(loading) return(
    <><MainLoader service={serviceName=="FaithFirst" ?"faith":"videos"}/></>
  )
 
  
}

export default Evina;
